export default {
    setLastPage(context, payload){
        context.commit('setLastPage', payload);
    }
}